import React from "react"
import BasicHero from "../../components/basic-hero"
import Calendly from "../../components/calendly/calendly"
import CTARow from "../../components/cta-row"
import { HandleImages } from "../../components/functions"
import GovInfo from "../../components/gov-infographic"
import Layout from "../../components/layout"
import Resource from "../../components/resource"
import ResourcesWrapper from "../../components/resources-wrapper"
import SEO from "../../components/seo"
import { seodata } from "../../components/seo-data"
import SimpleSlide from "../../components/simple-slide"
import SimpleSlider from "../../components/simple-slider"
import SocialSlider from "../../components/social-slider"




var image
var content = {
  hero: {
    title: <span>Outsmart Adversaries with Hands-On Cyber Range Training</span>,
    text: (
      <span>
    <p> Defending digital borders? Protecting threatened systems?</p><p> Whether a full or part-time cyber warrior (federal or regional),<strong> preparedness </strong>is the ultimate goal.</p> <p>Train for yourself, your unit, your community, your region. Because at the end of the day, a well-trained warrior can better halt cyber warfare and predict the unpredictable.</p><p><strong>Project Ares can be easily purchased with P-Card or GSA.</strong> It's an award-winning online cyber security training platform suitable for any business looking to persistently harden its posture with a people-first approach. We can help you:</p>
      </span>
    ),
  },

  calendly: {
    text:  <span>We'd love to learn about your agency or department.<br/>  Schedule a consultation with us now.</span>,
  },

  cta1: {
    title: "Incidents and Innovations in Government Cyber Security Training.",
    text:
      " ",
    url:
      "https://marketing.circadence.com/acton/fs/blocks/showLandingPage/a/36273/p/p-00dd/t/page/fm/0",
    cta: "Download Now",
  },
  cta2: {
    title: "Invest in your cyber security team!  ",
    text:
      "Learn more about Project Ares plans to keep professional's cyber skills sharp in your organization. ",
    url:
      "/project-ares",
    cta: "Learn More",
  },
  social: {
    social1: {
      image: "",
      title: "",
      text: (
        <span>
       With Project Ares, a well-known government organization found a cost-effective cyber learning solution to support joint, multi-service 

force training efforts, augment cyber curriculum development and help them achieve their goals.
          <span className="source">
             - European Defense Ministry
          </span>
        </span>
      ),
      url: "",
    },
  },
  //URL NEEDS UPDATE!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  resources: {
    resource1: {
      title: <span>Leveraging Cloud-Based Cyber Training for Improved Readiness<span>White Paper</span></span>,
     
      text:
        "Learn how hands-on cyber training can protect agencies of all sizes against attackers.",
      url:
        "https://marketing.circadence.com/acton/media/36273/white-paper-leveraging-cloud-based-cybersecurity-training-for-improved-readiness-for-state-and-local-governments ",
    },
    resource2: {
      title: <span>Protecting Democracy from Election Hacking<span>White Paper</span></span>,
    
      text:
        "A 5-Step implementation strategy to address global election integrity in the wake of digitalization.",
      url:        "https://marketing.circadence.com/acton/media/36273/protecting-democracy-from-election-hacking-white-paper",
    },
    resource3: {
      title: <span>Gamification for Cyber Professional Development <span>Fact Sheet</span></span>,
     
      text:
        "Learn why gamified learning can support skills training and acquisition for today’s cyber security professionals.",
      url:
        "https://marketing.circadence.com/acton/attachment/36273/f-1ebf399b-baed-420b-a651-3156c6cf248c/1/-/-/-/-/Gamification%20Fact%20Sheet%20%28links%20to%20gamification%20blog%20post%29.pdf",
    },
  },
  simple: {
    simple1: {
      text: <span><strong>Minimize your drill week </strong>through hands-on practice and testing of skills.</span>,
    },
    simple2: {
      text:
      <span><strong>Keep accurate training reports</strong> of progress.</span>,
    },
    simple3: {
      text:
      <span><strong>Limitless number of trainees</strong> can learn at any time, all at once, or on their terms.</span>,
    },
    simple4: {
      text:
      <span><strong>Provide an ever-present training environment</strong>  accessible anywhere in the world; ideal for remote training. </span>,
    },
   
  },
}

class LearnPage extends React.Component {
  render() {
    return (
      <Layout> <SEO title={seodata.gov.title} description={seodata.gov.description} keywords={seodata.gov.keywords} />
        <BasicHero
          title={content.hero.title}
          text={content.hero.text}
          image={<HandleImages name="govBuilding" />}
        />

    <GovInfo/>

<Calendly text={content.calendly.text} inv={true} bgColor={"bright-blue"} />

                
<SocialSlider>
    <SimpleSlide   image={<HandleImages name="genericMan" />} text={content.social.social1.text} />
   
 

        </SocialSlider>
        <CTARow
          title={content.cta1.title}
          text={content.cta1.text}
          cta={content.cta1.cta}
          url={content.cta1.url}
          inv={false}
          bgColor={"deep-blue"}
          image={"document"}
        />

 
        <ResourcesWrapper>
          <Resource
            image={<HandleImages name={"peopleScreen"} />}
            title={content.resources.resource1.title}
            text={content.resources.resource1.text}
            url={content.resources.resource1.url}
          />
          <Resource
            image={<HandleImages name={"vote"} />}
            title={content.resources.resource2.title}
            text={content.resources.resource2.text}
            url={content.resources.resource2.url}
          />
          <Resource
            image={<HandleImages name={"gamification"} />}
            title={content.resources.resource3.title}
            text={content.resources.resource3.text}
            url={content.resources.resource3.url}
          />
        </ResourcesWrapper>

        <SimpleSlider>
          <SimpleSlide
            image={<HandleImages name={"pAScreen1"} />}
            text={content.simple.simple1.text}
          />
          <SimpleSlide
            image={<HandleImages name={"aresTrainer"} />}
            text={content.simple.simple2.text}
          />
          <SimpleSlide
            image={<HandleImages name={"aresLeaderBoard"} />}
            text={content.simple.simple3.text}
          />
          <SimpleSlide
            image={<HandleImages name={"pAScreen4"} />}
            text={content.simple.simple4.text}
          />
         
        </SimpleSlider>
        <br />
    
        <CTARow
          title={content.cta2.title}
          text={content.cta2.text}
          cta={content.cta2.cta}
          url={content.cta2.url}
          
          bgColor={"bright-blue"}
          image={"laptop"}
        />


      </Layout>
    )
  }
}

export default LearnPage
